<div class="inline-block relative">
  <div class="popover-trigger">
    <ng-content select="[trigger]"></ng-content>
  </div>

  <p-popover
    #popover
    [showCloseIcon]="showCloseIcon()"
    [style]="{ width: width() }"
  >
    <div class="p-3">
      @if (title()) {
        <h3 class="mb-3 text-sm font-semibold">{{ title() }}</h3>
      }
      <ng-content></ng-content>
    </div>
  </p-popover>
</div>
